export const getPathAfterRoot = (fullPath, rootPath) => fullPath.replace(rootPath, '') || '/';
